import * as d3 from 'd3';
import { AnnotationModelItem, RectangleData } from '../interfaces';

export const drawRectangle = function (wrapper, item: AnnotationModelItem) {
  const data: RectangleData = item.data as RectangleData;
  const w = d3.select(wrapper);
  const rectangle: d3.Selection<SVGRectElement, unknown, null, undefined> = w.select(`#item${item.id}`).node()
    ? w.select(`#item${item.id}`)
    : w.append('rect');

  rectangle
    .attr('id', `item${item.id}`)
    .attr('stroke', data.color)
    .style('stroke-width', data.strokeWidth)
    .attr('width', data.size[0] || 1)
    .attr('height', data.size[1] || 1)
    .attr('fill', 'none');

  return rectangle;
};
